import { render, staticRenderFns } from "./moShiList.vue?vue&type=template&id=6ecd684e&scoped=true&"
import script from "./moShiList.vue?vue&type=script&lang=js&"
export * from "./moShiList.vue?vue&type=script&lang=js&"
import style0 from "./moShiList.vue?vue&type=style&index=0&id=6ecd684e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd684e",
  null
  
)

export default component.exports